import { List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import * as api from "api/Knowledge";
import { DefaultListParameters } from 'assets/appConfig';
import BoxDrawer from 'components/BoxDrawer';
import { SpinnerIndicator } from 'components/CallServer';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiMessageBox from 'components/MuiExtras/MessageBox/MuiMessageBox';
import MuiPagination from 'components/MuiExtras/MuiPagination';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import { WithSnackbar, withSnackbar } from 'components/SnackbarProvider/Snackbar';
import UserFullProfileLink from 'components/UserFullProfileLink';
import UserProfileAvatar from 'components/UserProfileAvatar';
import { Formaters } from 'lib/Formarters';
import { PublicationLikeReviewDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: PublicationLikeReviewDto;
    lastError: any;
    loading: boolean;
    offset: number;
}

interface IProps {
    publicationId: string;
    startDate?: Date;
    endDate?: Date;
    onClose: () => void;
}

type Props = IProps & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class PublicationLikesReviewDrawer extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            lastError: null,
            loading: true,
            offset: 0
        };
    }

    private loadData(offset: number) {
        this.setState({ loading: true, data: null });

        api.getLikeReviewList(this.props.publicationId, this.props.startDate, this.props.endDate, offset, DefaultListParameters.drawerRecordsByPage)
            .then((data) => {
                this.setState({ data, loading: false, offset: offset });
            })
            .catch((error) => {
                this.setState({ loading: false, offset: 0, lastError: error });
            });
    }


    public componentDidMount() {
        this.loadData(0);
    }

    public render() {
        const { onClose } = this.props;
        const { data, lastError, loading, offset } = this.state;

        return (
            <BoxDrawer
                open
                onClose={onClose}
                title={this.props.t("Views.Timeline.Dialogs.PublicationLikesReviewDrawer.BoxTitle")}
            >
                <MuiPaper dense fullHeight elevation={0}>
                    <GridEx container direction="column" wrap="nowrap" fullHeight>
                        <GridEx item xs overflow="auto">

                            {
                                lastError
                                    ? <MuiMessageBox variant="error" message={this.props.t("Views.Timeline.Dialogs.PublicationLikesReviewDrawer.LoadError")} />
                                    : loading
                                        ? <SpinnerIndicator />
                                        : data.total == 0
                                            ? <MuiMessageBox variant="info" message={this.props.t("Views.Timeline.Dialogs.PublicationLikesReviewDrawer.ListEmpty")} />
                                            : data.items && data.total > 0
                                                ? (
                                                    <>
                                                        <List dense disablePadding>
                                                            {
                                                                data.items.map((v, index) => {
                                                                    return (
                                                                        <ListItem key={index} disableGutters>
                                                                            <ListItemAvatar>
                                                                                <UserProfileAvatar user={v.user} />
                                                                            </ListItemAvatar>
                                                                            <ListItemText
                                                                                primary={<Typography variant="body2" component="div"><b><UserFullProfileLink user={v.user} /></b></Typography>}
                                                                                secondary={<Typography variant="body2" component="div"><MuiMuted><small>{Formaters.relativeTime(v.date)}</small></MuiMuted></Typography>}
                                                                                primaryTypographyProps={{ noWrap: true }}
                                                                            />
                                                                        </ListItem>
                                                                    );
                                                                })
                                                            }
                                                        </List>
                                                    </>
                                                )
                                                : null
                            }
                        </GridEx>

                        {
                            !lastError && !loading && data.items && data.total > 0 &&
                            <GridEx item>
                                <MuiPagination
                                    limit={DefaultListParameters.drawerRecordsByPage}
                                    offset={offset}
                                    total={data.total}
                                    onClick={(e, offset) => this.loadData(offset)}
                                />
                            </GridEx>
                        }
                    </GridEx>
                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withSnackbar(withTranslation()(PublicationLikesReviewDrawer));